import React, { FC } from 'react';

const Loader: FC<{ className?: string; width?: string }> = ({
  className,
  width,
}: {
  className?: string;
  width?: string;
}) => {
  return (
    <div className={'loader' + ' ' + (className ? className : '')}>
      <img src="/images/loader.svg" alt="loader" width={width} />
    </div>
  );
};
export default Loader;
